import './App.css';

function App() {
  return window.location.href = 'https://www.shoppbud.com.br';
}

export default App;
